var map = {
	"./Group111.svg": 7851,
	"./Group112.svg": 397,
	"./Group113.svg": 9746,
	"./Group114.svg": 4179,
	"./Group128.svg": 1855,
	"./Group129.svg": 7748,
	"./Group130.svg": 8096,
	"./Group131.svg": 3689,
	"./Group413.svg": 8070,
	"./Group420.svg": 6250,
	"./Group421.svg": 6221,
	"./Group95.svg": 8635,
	"./Group96.svg": 9795,
	"./Group97.svg": 4027,
	"./Group98.svg": 9630,
	"./i18nLogo.svg": 2884,
	"./lgcn.svg": 3403,
	"./lgen.svg": 3137,
	"./logo.svg": 6991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;